import script from "./CompoAPIComposables.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompoAPIComposables.vue?vue&type=script&setup=true&lang=ts"

import "./CompoAPIComposables.vue?vue&type=style&index=0&id=6bfdf117&lang=css"

const __exports__ = script;

export default __exports__